import React from "react";
import CurrentDayInformation from "@components/KeyInformation/CurrentDayInformation";
import Queries from "@components/KeyInformation/Queries";
import { PbiDashboard } from "@features/monthlyTourPlan";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";

/**
 * KeyInformation Page
 * Displays Power BI dashboard, current day information, and queries
 */
const KeyInformationPage = () => {
  usePageInitialization();

  return (
    <PageLayout title="Key Information" backPath="/">
      <PbiDashboard showDropdown={false} showDealer={true} />
      <CurrentDayInformation />
      <Queries />
    </PageLayout>
  );
};

export default KeyInformationPage;
